import { render, staticRenderFns } from "./MagicLink.vue?vue&type=template&id=1944090b&scoped=true&"
import script from "./MagicLink.vue?vue&type=script&lang=ts&"
export * from "./MagicLink.vue?vue&type=script&lang=ts&"
import style0 from "./MagicLink.vue?vue&type=style&index=0&id=1944090b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1944090b",
  null
  
)

export default component.exports